import { connect } from 'react-redux';

import Collaboration from 'shared/components/collaboration';
import {
  SHARED_BET_CLAIM_UPDATE,
  SHARED_BET_COMMENT,
  SHARED_BET_UPDATE_ATG,
  SHARED_BET_UPDATE_SPORT,
} from 'shared/constants/StompKind';
import {
  addComment,
  addSubscription,
  claimBet,
  deleteComment,
  expireClaim,
  fetchCollaborators,
  listComments,
  releaseBet,
  removeSubscription,
  showAtgShareDialog,
  showSportShareDialog,
  updateComment,
} from 'shared/redux/actions';
import { shares, user } from 'shared/redux/selectors';

const getTopicUrl = (betId, type) => {
  const typePath = type === 'atg' ? 'game' : 'sport';
  return `/topic/${typePath}-comments-${betId}`;
};

const getUpdateTopicUrl = (betId, type) => {
  const typePath = type === 'atg' ? 'bet' : 'sport';
  return `/topic/${typePath}-updated-${betId}`;
};

const getUpdateActionType = type =>
  type === 'sport' ? SHARED_BET_UPDATE_SPORT : SHARED_BET_UPDATE_ATG;

const getClaimUpdateTopicUrl = (betId, type) =>
  type === 'sport'
    ? `/topic/sportBetClaim-${betId}`
    : `/topic/betClaim-${betId}`;

const mapStateToProps = (state, { betId, type }) => ({
  comments: shares.getCommentsList(state, { betId, type }),
  commentsError: shares.getCommentsError(state, { betId, type }),
  loading: shares.isCommentsLoading(state, { betId, type }),
  claimStatus: shares.getClaimStatus(state, { betId, type }),
  collaborators: shares.getCollaboratorsList(state, { betId, type }),
  isLackingSubscription: type === 'atg' && !user.hasSubscription(state),
});

const mapDispatchToProps = (dispatch, { betId, type }) => ({
  addComment: comment => dispatch(addComment({ betId, type, comment })),
  updateComment: (commentId, comment) =>
    dispatch(updateComment({ betId, commentId, type, comment })),
  deleteComment: commentId =>
    dispatch(deleteComment({ betId, commentId, type })),
  listComments: () => dispatch(listComments({ betId, type })),
  fetchCollaborators: () => dispatch(fetchCollaborators({ betId, type })),
  addCollaborationSubscriptions: () => {
    dispatch(addSubscription(getTopicUrl(betId, type), SHARED_BET_COMMENT));
    dispatch(
      addSubscription(
        getUpdateTopicUrl(betId, type),
        getUpdateActionType(type),
      ),
    );
    dispatch(
      addSubscription(
        getClaimUpdateTopicUrl(betId, type),
        SHARED_BET_CLAIM_UPDATE,
      ),
    );
  },
  removeCollaborationSubscriptions: () => {
    dispatch(removeSubscription(getTopicUrl(betId, type)));
    dispatch(removeSubscription(getUpdateTopicUrl(betId, type)));
    dispatch(removeSubscription(getClaimUpdateTopicUrl(betId, type)));
  },
  claimBet: () => dispatch(claimBet({ betId, type })),
  expireClaim: () => dispatch(expireClaim({ betId, type })),
  releaseBet: () => dispatch(releaseBet({ betId, type })),
  openShareDialog: () => {
    if (type === 'sport') {
      dispatch(showSportShareDialog(betId, 'collaborate'));
    } else {
      dispatch(showAtgShareDialog(betId, 'collaborate'));
    }
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Collaboration);
